(() => {
  if (window.wosUglyWorld) return;
  window.wosUglyWorld = true;
  const initial = new URL(window.location.href).searchParams.get('uw_mood');
  let selected = ['ruhe', 'gluhwein', 'daneben'].includes(initial) ? initial : 'all';
  function apply() {
    const root = document.querySelector('.uw-catalog');
    if (!root) return;
    let count = 0;
    root.querySelectorAll('.grid-product[data-product-id]').forEach(card => {
      const mood = card.querySelector('[data-uw-mood]')?.dataset.uwMood || 'daneben';
      card.hidden = selected !== 'all' && mood !== selected;
      if (!card.hidden) count++;
    });
    root.querySelectorAll('[data-uw-filter]').forEach(button => {
      const active = button.dataset.uwFilter === selected;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });
    const status = root.querySelector('[data-uw-count]');
    if (status) status.textContent = `${count} ${status.dataset.label}`;
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('.uw-catalog [data-uw-filter]');
    if (!button) return;
    selected = button.dataset.uwFilter;
    const url = new URL(window.location.href);
    if (selected === 'all') url.searchParams.delete('uw_mood');
    else url.searchParams.set('uw_mood', selected);
    window.history.replaceState(window.history.state, '', url);
    apply();
    window.dispatchEvent(new Event('scroll'));
  });
  document.addEventListener('collection:reloaded', apply);
  document.addEventListener('shopify:section:load', apply);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
  else apply();
})();
